<template>
  <div>
    <div>
      <select class="form-control" name="data[is_included_vat]" v-model="is_included_vat" @change="calculateVats">
        <option :value="1">{{ trans('with_vat') }}</option>
        <option :value="0">{{ trans('no_vat') }}</option>
      </select>
      <button class="btn" @click.prevent="appendAmendmentProduct">{{ trans('append_amendment_product')}}</button>
    </div>
    <table class="table table-striped b-warehouse__table">
      <thead>
      <tr>
        <th class="col-xs-3" v-text="trans('grade')" style="text-align: left; vertical-align: middle"></th>
        <th class="col-xs-9">
          <table class="b-warehouse__variants-table">
            <tbody>
            <tr>
              <td class="col-xs-2 text-left" v-text="trans('pack')"></td>
              <td class="col-xs-1 text-left" v-text="trans('available_quantity')"></td>
              <td class="col-xs-1 text-left" v-text="trans('reserve')"></td>
              <td class="col-xs-1 text-left" v-text="trans('total_quantity')"></td>
              <td class="col-xs-1 text-left" v-text="trans('add_to_stock')"></td>
              <td class="col-xs-1 text-left" v-html="trans('purchase_price_of_batch')"></td>
              <td class="col-xs-1 text-left">
                {{ trans('vat')}}
                <select class="form-control input-sm b-warehouse__new-count"
                        v-model="set_all_vats" @change="setVatsForAllVariants">
                  <option v-for="vat in available_vats">{{ vat }}</option>
                </select>
              </td>
              <td class="col-xs-1 text-left" v-html="trans('calculated_vat')"></td>
              <td class="col-xs-1 text-left" v-html="trans('net_price')"></td>
            </tr>
            </tbody>
          </table>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="product in loaded_brand.products" :id="'product-' + product.id">
        <td>
                    <span class="b-warehouse__product-name" :data-product="product.id">
                        {{ product.name }}
                    </span>
        </td>
        <td>
          <table class="b-warehouse__variants-table">
            <tbody>
            <tr v-for="variant in product.variants">
              <td class="col-xs-2">{{ variant.title }}</td>
              <td class="col-xs-1">
                <span v-text="variant.available_quantity"></span>
              </td>
              <td class="col-xs-1">
                <span v-text="variant_reserves[variant.id]"></span>
              </td>
              <td class="col-xs-1">
                <span v-text="variant.available_quantity + variant_reserves[variant.id]"></span>
              </td>
              <!-- Добавить на склад -->
              <td class="col-xs-1">
                <input
                    class="form-control input-sm b-warehouse__new-count"
                    type="number"
                    min="0"
                    step="1"
                    :name="'data[' + variant.id + '][quantity]'"
                    v-model="quantities[variant.id]"
                    @change="calculateVats"
                >
              </td>
              <!-- Цена партии -->
              <td class="col-xs-1">
                <input
                    class="form-control input-sm b-warehouse__new-count"
                    type="number"
                    tabindex="-1"
                    min="0"
                    step="0.0001"
                    @change="calculateVats"
                    v-model="purchase_prices[variant.id]"
                    :name="'data[' + variant.id + '][price]'"
                    :disabled="!quantities[variant.id] || quantities[variant.id] == 0"
                    :required="quantities[variant.id] > 0"
                >
              </td>
              <!-- Ндс партии -->
              <td class="col-xs-1">
                <select class="form-control input-sm b-warehouse__new-count"
                        :name="'data[' + variant.id + '][vat]'"
                        v-model="vats[variant.id]" @change="calculateVats">
                  <option v-for="vat in available_vats">{{ vat }}</option>
                </select>
              </td>
              <!-- Ндс партии -->
              <td class="col-xs-1">
                <input
                    class="form-control input-sm b-warehouse__new-count"
                    type="number"
                    tabindex="-1"
                    min="0"
                    step="1"
                    v-bind:readonly="true"
                    :name="'data[' + variant.id + '][calculated_vats]'"
                    v-model="calculated_vats[variant.id]"
                >
              </td>
              <!-- Ндс партии -->
              <td class="col-xs-1">
                <input
                    class="form-control input-sm b-warehouse__new-count"
                    type="number"
                    tabindex="-1"
                    min="0"
                    step="1"
                    v-bind:readonly="true"
                    :name="'data[' + variant.id + '][net_prices]'"
                    v-model="calculated_net_prices[variant.id]"
                >
              </td>
            </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td class="col-6 text-left">{{ trans('total_net') }}</td>
        <td class="col-6 text-left">{{ total_net_price }}</td>
      </tr>
      <tr>
        <td class="col-6 text-left">{{ trans('total_vat') }}</td>
        <td class="col-6 text-left">{{ total_vat }}</td>
      </tr>
      <tr>
        <td class="col-6 text-left">{{ trans('total_price') }}</td>
        <td class="col-6 text-left">{{ total_price }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
let Functions = require("../../Functions");

module.exports = {
      props: ['loaded_brand', 'variant_reserves', 'translations', 'available_vats'],
      data: function () {
        return {
          quantities: [],
          purchase_prices: [],
          set_all_vats: 0,
          vats: [],
          is_included_vat: 0,
          calculated_vats: [],
          calculated_net_prices: [],
          total_vat: 0,
          total_net_price: 0,
          total_price: 0,
          amendment_product_was_loaded: false,
        }
      },
      watch: {
        loaded_brand() {
            this.total_vat = 0;
            this.total_net_price = 0;
            this.total_price = 0;
          }
      },
      methods: {
        trans(name, path = 'stock') {
          return Functions.trans(this.translations, name, path);
        },
        calculateVats() {
            let requestParams = this.prepareRequest();
            if(requestParams.length === 0) {
                return;
            }
            this.$http
              .post('/warehouse/incoming/calculate_vat', {variants: requestParams})
              .then((response) => {
                  let data = response.data;
                  this.total_net_price = data.total_net_price;
                  this.total_vat = data.total_vat;
                  this.total_price = data.total_price;
                  data.calculated_variants.forEach(calculatedVat => {
                    let variantId = calculatedVat.variant_id;
                    this.calculated_net_prices[variantId] = calculatedVat.net_price;
                    this.calculated_vats[variantId] = calculatedVat.calculated_vat;
                  });
              });
        },
        prepareRequest() {
          let requestParams = [];
          let quantitiesFilledIds = Object.keys(this.quantities);
          let pricesFilledIds = Object.keys(this.purchase_prices);
          let vats = Object.keys(this.vats);
          let filledAllInputsByVariantIds = this.intersection(quantitiesFilledIds, pricesFilledIds);
          filledAllInputsByVariantIds = this.intersection(filledAllInputsByVariantIds, vats);

          filledAllInputsByVariantIds.forEach(filledVariantId => {
              let filledVariant = {
                 'variant_id' : filledVariantId,
                 'purchase_price': this.purchase_prices[filledVariantId],
                 'quantity' : this.quantities[filledVariantId],
                 'vat' : this.vats[filledVariantId],
                 'is_included_vat' : this.is_included_vat,
              };
              requestParams.push(filledVariant);
          });

          return requestParams;
        },

         intersection(arr1, arr2) {
          return arr1.filter(elem => arr2.includes(elem));
        },

        appendAmendmentProduct() {
          if(this.amendment_product_was_loaded) {
            return;
          }
          this.$http
              .get('/warehouse/incoming/load_amendment_product', {})
              .then((response) => {
                let data = response.data;
                if(!data.product || !data.variant_reserves) {
                   return;
                }
                this.appendVariantReserves(data.variant_reserves);
                this.loaded_brand.products.push(data.product);
                this.amendment_product_was_loaded = true;
              });
        },

        appendVariantReserves(variantReserves) {
          for (const [variantId, reserve] of Object.entries(variantReserves)) {
            this.variant_reserves[variantId] = reserve;
          }
        },

        setVatsForAllVariants() {
          this.loaded_brand.products.forEach(product => {
             product.variants.forEach(variant => {
                this.vats[variant.id] = this.set_all_vats;
             });
          });
          this.calculateVats();
        },
      },
};
</script>
